import React, { useCallback, useRef } from "react";
import useCMS from "./hooks/useCMS";
import useForm from "./hooks/useForm";
import { useState, useDispatch } from "./hooks/useState";
import { usePost } from "./hooks/useApi";
import Button from "./ui/Button";
import Spinner from "./ui/Spinner";
import TextInput from "./ui/TextInput";
import { pattern } from "./utils";

function PersonalNumberForm() {
  const { translations } = useCMS();
  const {
    handleSubmit,
    formState,
    fieldRequired,
    setValue,
    registerField
  } = useForm("onChange");
  const { token } = useState();
  const { setApiValues, setPersonalNumber, setError } = useDispatch();

	const personalNumberRef = useRef(null);

  const onResolve = useCallback(
    res => {
      const {
        IdCompany,
        IdPerson,
        IdSos,
        IdAgreementVab,
        IdAgreementSos,
        ReportType,
        ShowExternalInfo,
        ExternalInfo,
        AdvisingAgreement,
        NoAfterRegistration,
        VabAgreement,
        ErrorCode,
        ReportReceived,
				VabShowExternalInfo,
				VabNoAfterRegistration,
				VabExternalInfo,
				VabAdvisingAgreement,
				AbsenceAgreement
      } = res.data;

      if (ErrorCode) {
        setError(ErrorCode);
      } else {
        setApiValues(
          { IdAgreementSos, IdAgreementVab, IdCompany, IdPerson, IdSos },
          ReportType,
          AdvisingAgreement,
          VabAgreement,
          !NoAfterRegistration,
          ShowExternalInfo ? ExternalInfo : null,
          ReportReceived,
					!VabNoAfterRegistration,
					VabShowExternalInfo ? VabExternalInfo : null,
					VabAdvisingAgreement,
					AbsenceAgreement
        );
        setPersonalNumber(personalNumberRef.current);
      }
    },
    [setError, setApiValues, setPersonalNumber]
  );

  const { post, isPending } = usePost("CheckPersonalNumber", { onResolve });

  const onInputChange = useCallback(event => {
    let value = event.target.value;
    if (value.length > 1) {
      const year = event.target.value.slice(0, 2);
      if (!/^(19|20)$/.test(year)) {
        if (year.startsWith("0") || year.startsWith("1")) {
          value = `20${event.target.value}`;
        } else {
          value = `19${event.target.value}`;
        }
      }
    }

    setValue("PersonalNumber", value);
  }, []);

  const onSubmit = useCallback(
    ({ PersonalNumber }) => {
      personalNumberRef.current = PersonalNumber;
      post({ PersonalNumber, Token: token });
    },
    [post, token]
  );

  return (
    <div className="content">
      {isPending && (
        <div className="info-box">
          <Spinner>{translations.checkingpersonalnumber}</Spinner>
        </div>
      )}
      {!isPending && (
        <form onSubmit={handleSubmit(onSubmit)}>
          <TextInput
            {...registerField("PersonalNumber")}
            placeholder="YYMMDDXXXX"
            inputMode="numeric"
            htmlPattern="\d*"
            pattern={{
              value: pattern.SSN,
              message: translations.wrongformat
            }}
            onChange={onInputChange}
            minLength={{ value: 10, message: translations.wrongformat }}
            required={fieldRequired}
          >
            {translations.personalnumber}
          </TextInput>

          <Button type="submit" disabled={!formState.isValid}>
            {translations.continue}
          </Button>
        </form>
      )}
    </div>
  );
}

export default PersonalNumberForm;
